export const SAVE_FOR_LATER = 'Save For Later'
export const TO_VIEW_YOUR_SAVED_ITEMS = 'To view your saved items across devices and during future visits, please'
export const ALL_SAVED_ITEMS = 'All saved items that are compatible with your'
export const LOGIN_MOBILE_URL = '/login-mobile'
export const CREATE_ACCOUNT_URL = '/my-account/register'
